(function () {
  'use strict';

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function yen(n) { return '¥' + Math.round(n / 100).toLocaleString('en-US'); }

  function fetchCart() {
    return fetch('/cart.js').then(function (res) { return res.json(); });
  }

  function changeLine(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity }),
    })
      .then(function (res) { return res.json(); })
      .then(render);
  }

  function render(cart) {
    var hasItems = document.getElementById('cart-has-items');
    var empty = document.getElementById('cart-empty');

    if (cart.items.length === 0) { hasItems.hidden = true; empty.hidden = false; return; }
    hasItems.hidden = false;
    empty.hidden = true;

    document.getElementById('cart-items').innerHTML = cart.items.map(function (item, i) {
      var line = i + 1;
      var variantLabel = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      return '<div class="ak-cart__item" data-line="' + line + '">' +
        '<div class="ak-cart__item-info">' +
        '<a href="' + esc(item.url) + '" class="ak-cart__item-media"><img src="' + esc(item.image) + '" alt=""></a>' +
        '<div class="ak-cart__item-text"><a href="' + esc(item.url) + '">' + esc(item.product_title) + '</a><span class="ak-cart__item-price">' + yen(item.price) + '</span><span class="ak-cart__item-variant">' + esc(variantLabel) + '</span></div>' +
        '</div>' +
        '<div class="ak-cart__item-qty"><div><button type="button" class="qty-step" data-dec>−</button><span>' + item.quantity + '</span><button type="button" class="qty-step" data-inc>+</button></div><button type="button" class="ak-cart__item-remove" data-remove>削除</button></div>' +
        '<span class="ak-cart__item-total">' + yen(item.line_price) + '</span>' +
        '</div>';
    }).join('');

    var subtotal = cart.items_subtotal_price;
    var freeShip = subtotal >= 800000;
    var discount = cart.total_discount;
    var total = cart.total_price;

    document.getElementById('cart-subtotal').textContent = yen(subtotal);
    var shipEl = document.getElementById('cart-shipping');
    shipEl.textContent = freeShip ? '無料' : '購入手続き時に計算';
    shipEl.style.color = freeShip ? '#1f8a5b' : '#101018';
    var discEl = document.getElementById('cart-discount');
    discEl.textContent = discount > 0 ? ('−' + yen(discount)) : '¥0';
    discEl.style.color = discount > 0 ? '#c0392b' : '#101018';
    document.getElementById('cart-total').innerHTML = yen(total) + ' <span style="font-size:14px;color:#6b6b76">JPY</span>';

    document.querySelectorAll('#cart-items [data-line]').forEach(function (row) {
      var line = parseInt(row.getAttribute('data-line'), 10);
      var qtySpan = row.querySelector('.ak-cart__item-qty span');
      row.querySelector('[data-inc]').addEventListener('click', function () { changeLine(line, parseInt(qtySpan.textContent, 10) + 1); });
      row.querySelector('[data-dec]').addEventListener('click', function () { changeLine(line, parseInt(qtySpan.textContent, 10) - 1); });
      row.querySelector('[data-remove]').addEventListener('click', function () { changeLine(line, 0); });
    });
  }

  function init() {
    var promoApply = document.getElementById('cart-promo-apply');
    if (promoApply) {
      promoApply.addEventListener('click', function () {
        var code = (document.getElementById('cart-promo-input').value || '').trim();
        if (!code) return;
        // Shopifyの割引コードはチェックアウト側で検証・適用される(カート内では検証できない)
        window.location.href = '/checkout?discount=' + encodeURIComponent(code);
      });
    }
    fetchCart().then(render);
  }

  document.addEventListener('DOMContentLoaded', init);
})();
